import { mergeProps as _mergeProps, createTextVNode as _createTextVNode, createVNode as _createVNode } from "vue";
export default {
  name: 'BallVolleyballIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return _createVNode("svg", _mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-ball-volleyball",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [_createTextVNode("   "), _createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), _createTextVNode("   "), _createVNode("path", {
      "d": "M12 12m-9 0a9 9 0 1 0 18 0a9 9 0 1 0 -18 0"
    }, null), _createTextVNode("   "), _createVNode("path", {
      "d": "M12 12a8 8 0 0 0 8 4"
    }, null), _createTextVNode("   "), _createVNode("path", {
      "d": "M7.5 13.5a12 12 0 0 0 8.5 6.5"
    }, null), _createTextVNode("   "), _createVNode("path", {
      "d": "M12 12a8 8 0 0 0 -7.464 4.928"
    }, null), _createTextVNode("   "), _createVNode("path", {
      "d": "M12.951 7.353a12 12 0 0 0 -9.88 4.111"
    }, null), _createTextVNode("   "), _createVNode("path", {
      "d": "M12 12a8 8 0 0 0 -.536 -8.928"
    }, null), _createTextVNode("   "), _createVNode("path", {
      "d": "M15.549 15.147a12 12 0 0 0 1.38 -10.611"
    }, null), _createTextVNode(" ")]);
  }
};